import { useFormikContext } from 'formik'
import React from 'react'
import { PatientHistoryEntry } from 'src/legacy/components/ParticipantRecords/ParticipantHistory/types'
import { PatientHistoryFormType } from 'src/participantHistory/constants'
import { NoteDraftAlerts } from 'src/noteDraft/NoteDraftAlerts'
import { useNoteDraftAutosave, useUnsavedNoteDraftPrompt } from 'src/noteDraft/useNoteDraft'

type FormPersistorProps = { formType: PatientHistoryFormType; uid: string }

const FormPersistor = ({ formType, uid }: FormPersistorProps) => {
  const { values, dirty, isSubmitting } = useFormikContext<PatientHistoryEntry>()
  const type = String(formType)

  useNoteDraftAutosave({ uid, type, values, enabled: dirty && !isSubmitting, submitting: isSubmitting })
  useUnsavedNoteDraftPrompt({ uid, type, values })

  return <NoteDraftAlerts uid={uid} formType={type} />
}

export default FormPersistor
